<template lang="pug">
el-container
  el-header(height="80px")
    el-menu.el-menu-demo(:default-active="activeIndex", mode="horizontal", @select="handleSelect", id="elMenu" )
      el-menu-item(@click="back()") 后退
      el-menu-item(index="/qingShuiIndex") 首页
      el-submenu(index="/qingShui/airStationOne")
        template(slot="title") 空气制备站
        el-menu-item(index="/qingShui/airStationOne") 1号空气制备站
        el-menu-item(index="/qingShui/airStationTwo") 2号空气制备站
        el-menu-item(index="/qingShui/airStationThree") 3号空气制备站
        el-menu-item(index="/qingShui/airStationFour") 4号空气制备站
        el-menu-item(index="/qingShui/airStationFive") 5号空气制备站
        el-menu-item(index="/qingShui/airStationSix") 6号空气制备站
      el-submenu(index="/qingShui/pressureFan")
        template(slot="title") 高压风机
        el-menu-item(index="/qingShui/pressureFanFive") 5号空气制备站高压风机
        el-menu-item(index="/qingShui/pressureFanSix") 6号空气制备站高压风机
      el-menu-item(index="/qingShui/gasClamp") 气夹数据
      el-menu-item(index="/qingShui/bridgeImg") 全桥除湿总体布置图
      el-submenu(index="/qingShui/dataHistory?bridgeId=7553a665-0928-4416-9389-98e7cda26f0c&scenarioId=TBD")
        template(slot="title") 数据历史
        el-menu-item(index="/qingShui/dataHistory?bridgeId=7553a665-0928-4416-9389-98e7cda26f0c&scenarioId=TBD") 查询数据历史
        el-menu-item(index="/qingShui/dataHistory?bridgeId=7553a665-0928-4416-9389-98e7cda26f0c") 自定义数据历史
    HeaderTime(bridgeName="GUIZHOU", :bridgeId="bridgeId", :id2Path="id2Path", :envInfo="envInfo")
  el-main.qing-shui
    router-view
</template>
<script>
export default {
  name: "qingshui",
  data() {
    return {
      bridgeId: "7553a665-0928-4416-9389-98e7cda26f0c",
      envInfo: {
        envId: "f4bbb4f1-9a9e-4747-aa57-0637474c060d",
        weather: "e7b0ea43-8357-4ca0-b621-439c49a2fb9e",
        humidity: "4212f138-aa97-420d-a61b-28991b725c04",
        temperature: "cb678a9e-bf43-44fc-9eb4-1378fdfba689",
      },
      id2Path: {
        "56a96626-a9f2-46cb-bf3c-02a01cbea4b1": "airStationOne",
        "0e298c23-9326-437c-b2d2-067f634cdd27": "airStationTwo",
        "72f35082-9439-4ec3-8cf3-79e04c5c663c": "airStationThree",
        "55afc2be-8d18-4852-b8f8-3e39229ebef5": "airStationFour",
        "3623a806-57de-4c36-bfc0-b1cddffaebb9": "airStationFive",
        "464f8e80-e525-45b4-885c-e07940e237d2": "pressureFanFive",
        "01f14fb5-bd4d-4efd-b333-8a3aa2115f89": "airStationSix",
        "7618ff66-8e69-49e0-ac8d-d5dc424b1879": "pressureFanSix",
        "9975ea8e-e227-4d89-aaac-d583f1fa1c58": "gasClamp",
        "5423cf90-2511-4070-aac9-2bb64f15f0a3": "gasClamp",
      },
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

     document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

  <style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;;
  display: none;
}
</style>
